import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getKpis,
  getChartData,
  exportChart,
} from "../../services/analyticsService";

export const fetchKpisThunk = createAsyncThunk(
  "analytics/fetchKpis",
  async (filters = {}, { rejectWithValue }) => {
    try {
      const response = await getKpis(filters);
      return response.data?.data || response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch KPIs"
      );
    }
  }
);

export const fetchChartDataThunk = createAsyncThunk(
  "analytics/fetchChart",
  async ({ chartType, params = {} }, { rejectWithValue }) => {
    try {
      const response = await getChartData({ ...params, type: chartType });
      return {
        chartType,
        data: response.data?.data || response.data,
      };
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch chart data"
      );
    }
  }
);

export const exportChartThunk = createAsyncThunk(
  "analytics/exportChart",
  async ({ chartElement, fileName }, { rejectWithValue }) => {
    try {
      // Using html2canvas if available
      if (window.html2canvas) {
        const canvas = await window.html2canvas(chartElement);
        const url = canvas.toDataURL("image/png");
        const link = document.createElement("a");
        link.href = url;
        link.download =
          fileName || `chart_${new Date().toISOString().split("T")[0]}.png`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        return { success: true };
      } else {
        throw new Error("html2canvas not available");
      }
    } catch (error) {
      return rejectWithValue("Failed to export chart");
    }
  }
);
